import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Heart, UserPlus, Clock } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function MentorCard() {
  const { user, refreshUser } = useAuth();
  const [requesting, setRequesting] = useState(false);

  // Não mostrar se já for mentor
  if (!user || user.is_mentor) return null;

  // Se já solicitou, mostrar status pendente
  if (user.mentor_request_pending) {
    return (
      <Card className="bg-gradient-to-br from-purple-50 to-indigo-50 border-2 border-purple-200">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-lg">
            <Heart className="h-5 w-5 text-purple-600" />
            Grupo de Mentores
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2 mb-3">
            <Badge className="bg-orange-100 text-orange-800 border-orange-300">
              <Clock className="h-3 w-3 mr-1" />
              Solicitação Pendente
            </Badge>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed">
            Sua solicitação está sendo analisada pela nossa equipe. 
            Em breve você receberá uma resposta.
          </p>
        </CardContent>
      </Card>
    );
  }

  const handleRequestMentor = async () => {
    if (!window.confirm('Deseja solicitar o status de Mentor? Nossa equipe irá analisar sua solicitação.')) {
      return;
    }

    setRequesting(true);
    try {
      const token = localStorage.getItem('token');
      const baseUrl = import.meta.env.VITE_REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
      
      const response = await fetch(`${baseUrl}/api/me/request-mentor`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao solicitar status de Mentor');
      }

      toast.success('Solicitação enviada com sucesso!');
      // Atualizar usuário
      await refreshUser();
    } catch (error) {
      console.error('Failed to request mentor:', error);
      toast.error(error.message || 'Erro ao solicitar status de Mentor');
    } finally {
      setRequesting(false);
    }
  };

  return (
    <Card className="bg-gradient-to-br from-purple-50 to-indigo-50 border-2 border-purple-200">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Heart className="h-5 w-5 text-purple-600" />
          Grupo de Mentores
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-gray-700 mb-4 leading-relaxed">
          Se você já está em recuperação há algum tempo e deseja <strong>ajudar outros membros</strong> 
          da comunidade, considere se tornar um <strong>Mentor</strong>. Mentores recebem um selo 
          especial e podem guiar outros na jornada.
        </p>
        <Button
          onClick={handleRequestMentor}
          disabled={requesting}
          className="w-full bg-purple-600 hover:bg-purple-700"
          size="sm"
        >
          <UserPlus className="h-4 w-4 mr-2" />
          {requesting ? 'Enviando...' : 'Quero ser Mentor'}
        </Button>
      </CardContent>
    </Card>
  );
}
